module.exports = __webpack_public_path__ + "img/sp_app_notice_student.64efe8a9.png";